import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapService } from './map.service';

/**
 * Helper service for using Google Street View.
 * Used to communicate the Google Street View component with the rest of the application.
 */
@Injectable({
  providedIn: 'root'
})
export class GoogleStreetViewService {
  /** The key of the position marker added to OpenLayers of the current position and orientation of the user. */
  STREET_VIEW_MARKER_TITLE = 'STREET_VIEW_MARKER';

  /** The global StreetViewPanorama object. */
  streetViewPanorama: google.maps.StreetViewPanorama = null;

  /** Variable to indicate if the StreetView component is ready to be used. */
  private _ready: boolean = false;
  public get ready(): boolean {
    return this._ready;
  }
  public set ready(val: boolean) {
    this._ready = val;
    this.readyChange.next(this._ready);
  }
  readyChange: Subject<boolean> = new Subject(); //The subscription to the changes.

  /** Variable to indicate if the StreetView component is currently active */
  private _isActive: boolean = false;
  public get isActive(): boolean {
    return this._isActive;
  }
  /**
   * Street View è un tool "weak" del click sulla mappa: se c'è già uno strumento aperto non si attiva (il registro mostra l'errore),
   * e si chiude da solo quando si apre un tool "strong".
   */
  public set isActive(val: boolean) {
    if (val === this._isActive) {
      return;
    }
    if (val) {
      const granted = this._mapService.acquireMapClick({
        id: GoogleStreetViewService.CLICK_OWNER_ID,
        level: 'weak',
        // il registro è già stato aggiornato: non va rilasciato
        onYield: () => this._setActive(false)
      });
      if (!granted) {
        return;
      }
    } else {
      this._mapService.releaseMapClick(GoogleStreetViewService.CLICK_OWNER_ID);
    }
    this._setActive(val);
  }
  isActiveChange: Subject<boolean> = new Subject(); //The subscription to the changes.

  private static readonly CLICK_OWNER_ID = 'street-view';

  constructor(private _mapService: MapService) {}

  private _setActive(val: boolean): void {
    this._isActive = val;
    this.isActiveChange.next(this._isActive);
  }
}
